import React, {useState} from 'react';
import {Grid, ThemeProvider} from "@mui/material";
import {theme} from "../Theme";
import {WelcomeAssistantContext, WelcomeAssistantContextType} from "./ContextType";
import {Stage1} from "./Stages/Stage1";
import {MoneyRange} from "./Types/MoneyRange";
import {ProgressInfoBox} from "./ProgressInfoBox";
import {Stage2} from "./Stages/Stage2";
import {Stage3} from "./Stages/Stage3";
import {SlideDirection} from "./Types/SlideDirection";
import {WelcomeAssistantStages} from "./WelcomeAssistantStages";
import {fireEvent} from "../Tracking/FireEvent";

interface WelcomeAssistantProps {
    config: {
        type: string,
    }
}

export function WelcomeAssistant(props: WelcomeAssistantProps) {

    const [numStages, setNumStages] = useState(3);
    const [currentStage, setCurrentStage] = useState(1);
    const [currentStageNumberToDisplay, setCurrentStageNumberToDisplay] = useState(1);
    const [maxStageReached, setMaxStageReached] = useState(0);
    const [equityCapitalState, setEquityCapitalState] = useState<MoneyRange>();
    const [monthlyInvestState, setMonthlyInvestState] = useState<MoneyRange>();
    const [yourName, setYourName] = useState('');
    const [yourMail, setYourMail] = useState('');
    const [yourMobile, setYourMobile] = useState('');
    const [slideDirection, setSlideDirection] = useState(SlideDirection.Left);
    const [newsletterConsent, setNewsletterConsent] = useState(true);
    const [source, setSource] = useState('');

    let ctx: WelcomeAssistantContextType = {
        type: props.config.type,
        newsletterConsent: newsletterConsent,
        setNewsletterConsent: setNewsletterConsent,
        currentStageNumberToDisplay: currentStageNumberToDisplay,
        equityCapitalState: equityCapitalState,
        setEquityCapitalState: setEquityCapitalState,
        monthlyInvestState: monthlyInvestState,
        setMonthlyInvestState: setMonthlyInvestState,
        yourName: yourName,
        setYourName: setYourName,
        yourMail: yourMail,
        setYourMail: setYourMail,
        yourMobile: yourMobile,
        setYourMobile: setYourMobile,
        numStages: numStages,
        setNumStages: setNumStages,
        currentStage: currentStage,
        handleGoToStage: (stage) => setCurrentStage(stage),
        handleNext: (increaseStepNumber) => {
            setSlideDirection(SlideDirection.Right);
            if (increaseStepNumber) {
                setCurrentStageNumberToDisplay(currentStageNumberToDisplay + 1);
            }
            if (maxStageReached < currentStage) {
                fireEvent('welcome-assistant-page-' + currentStage + '-completed');
            }

            setMaxStageReached(Math.max(maxStageReached, currentStage));
            setCurrentStage(currentStage + 1);
        },
        handlePrev: (decreaseStepNumber) => {
            setSlideDirection(SlideDirection.Left);
            if (decreaseStepNumber) {
                setCurrentStageNumberToDisplay(currentStageNumberToDisplay - 1);
            }
            setCurrentStage(currentStage - 1);
        },
        slideDirection: slideDirection,
        setSlideDirection: setSlideDirection,
        source: source,
        setSource: setSource,
    };

    return (
        <ThemeProvider theme={theme}>
            <WelcomeAssistantContext.Provider value={ctx}>
                <Grid container>
                    <ProgressInfoBox/>
                    <WelcomeAssistantStages>
                        <Stage1/>
                        <Stage2/>
                        <Stage3/>
                    </WelcomeAssistantStages>
                </Grid>
            </WelcomeAssistantContext.Provider>
        </ThemeProvider>
    );
}